<template>
  <section class="category">
    <div class="inner">
      <h1 class="category-heading">
        <page-link :to="'/' + category.url">{{category.name}}</page-link>
      </h1>
      <div class="category-grid" v-if="category.products">
        <page-link
          :key="product.ItemID"
          :to="product.url"
          class="product-thumb"
          v-for="product in productList"
          v-tooltip="{
            content: product.promo
          }"
        >
          <img
            :alt="product.name"
            :src="product.images[0].image"
            v-if="product.images && product.images.length"
          />
          <span class="product-thumb-title">{{product.name}}</span>
          <span class="product-thumb-price">from &pound;{{product.base_price}}</span>
          <span class="product-thumb-view">
            <img alt="Configure and buy" src="../assets/ripple.svg" /> configure and buy
          </span>
        </page-link>
      </div>
      <page-link :to="category.url" class="category-more" v-if="isHomePage">
        <img alt="View all" src="../assets/ripple.svg" />
        View all {{category.name}}
      </page-link>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "Category",
  props: ["category"],
  computed: {
    ...mapGetters(["isHomePage"]),
    productList: function() {
      if (!this.category.products) return []

      if (this.isHomePage) return this.category.products.slice(0, 4)
      else return this.category.products
    }
  }
}
</script>

<style scoped>
.category {
  margin: 3rem 0;
  font-size: 1.5rem;
}

.category .inner {
  border: 1px solid #eaeaea;
  padding: 3rem 3%;
  padding-bottom: 2rem;
}

.category-more img {
  width: 2.5rem;
  display: inline-block;
  height: 2.5rem;
  margin-bottom: -0.5rem;
  margin-right: 0.5rem;
}

.category-more {
  display: block;
  max-width: 330px;
  text-align: center;
  color: white;
  background-color: #455051;
  padding: 0.5rem 1rem;
  font-size: 1.8rem;
  border-bottom: 5px solid #f79227;
  margin: 1.5rem auto;
}

.category-grid {
  display: table;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 5rem;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .category-grid > * {
    width: 25%;
    padding-left: 1%;
    padding-right: 2%;
    float: left;
    min-height: 45rem;
  }
}

.product-thumb * {
  transition: all 0.4s;
}

.product-thumb > img {
  width: 95%;
  display: block;
  margin: auto;
}

.product-thumb span {
  display: block;
}

.product-thumb-title {
  font-size: 2rem;
  font-weight: bold;
  color: #414e4f;
  line-height: 1.5;
  margin-top: 1rem;
}

.product-thumb-price {
  font-size: 1.7rem;
  font-weight: bold;
  color: #f79227;
}

.product-thumb-view {
  margin-top: 10px;
  opacity: 0;
  background: #414e4f;
  color: white;
  text-align: center;
  padding: 0.5rem;
}

.product-thumb:hover .product-thumb-view {
  margin-top: 5px;
  opacity: 1;
}

.product-thumb:hover > img {
  transform: scale(1.05);
}

.product-thumb-view img {
  width: 2rem;
  display: inline-block;
  height: 2rem;
  margin-bottom: -0.5rem;
  margin-right: 0.5rem;
}

@media screen and (max-width: 750px) {
  .category-grid {
    display: table;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0rem 5rem;
  }
  .category-heading {
    margin-bottom: 3rem;
  }
  .product-thumb {
    text-align: center;
  }
}
</style>
